
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M10 5v10m5-5H5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-width=\"1.5\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest && dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
